import FounderProfile from '@src/pages/members/profile/[memberSlug]'

// L7: 404 for an unknown slug/id, 410 for a profile this viewer may not see (cookies forwarded).
export { memberProfileGetServerSideProps as getServerSideProps } from '@src/lib/memberProfileServerSideProps'

export default FounderProfile
